"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PIXIGraphicOverride = PIXIGraphicOverride;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _pixi = require("pixi.js");
/**
 * PIXI.Graphics을 createjs.Shape와 비슷한 인터페이스로 구현하기 위한 함수
 *
 */
var GraphicsAdaptor = /*#__PURE__*/function () {
  function GraphicsAdaptor(gra) {
    (0, _classCallCheck2["default"])(this, GraphicsAdaptor);
    /**
     * @private
     * @type {PIXI.Graphics}
     */
    this._gra = gra;
    this._lineStyleChanged = false;
    this._lineStyle = {
      alpha: 1,
      color: 0,
      thickness: 0
    };
    this._fillStyle = {
      alpha: 1,
      color: 0
    };
  }
  return (0, _createClass2["default"])(GraphicsAdaptor, [{
    key: "moveTo",
    value: function moveTo(x, y) {
      this._gra.moveTo(x, y);
      return this;
    }
  }, {
    key: "beginFill",
    value: function beginFill(color) {
      var style = this._fillStyle;
      this._parseRGBCssStyleColor(color, style);
      this._gra.beginFill(style.color, style.alpha);
      return this;
    }
  }, {
    key: "beginStroke",
    value: function beginStroke(color) {
      this._parseRGBCssStyleColor(color, this._lineStyle);
      this._lineStyleChanged = true;
      this._setStrokeStyle();
      return this;
    }
  }, {
    key: "drawRoundRect",
    value: function drawRoundRect(x, y, w, h, r) {
      this._gra.drawRoundedRect(x, y, w, h, r);
      return this;
    }
  }, {
    key: "drawCircle",
    value: function drawCircle(x, y, r) {
      this._gra.drawCircle(x, y, r);
      return this;
    }
  }, {
    key: "lineTo",
    value: function lineTo(x, y) {
      this._gra.lineTo(x, y);
      return this;
    }
  }, {
    key: "clear",
    value: function clear() {
      this._gra.clear();
      return this;
    }
  }, {
    key: "setStrokeStyle",
    value: function setStrokeStyle(thickness) {
      var caps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var joints = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var miterLimit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 10;
      this._lineStyleChanged = true;
      this._lineStyle.thickness = thickness;
      this._setStrokeStyle();
      return this;
    }
  }, {
    key: "drawRect",
    value: function drawRect(x, y, w, h) {
      this._gra.drawRect(x, y, w, h);
      return this;
    }
  }, {
    key: "closePath",
    value: function closePath() {
      this._gra.closePath();
      return this;
    }
  }, {
    key: "endStroke",
    value: function endStroke() {
      //todo [박준배] endStroke에 해당하는 pixi 메서드를 찾아서 넣어주긔.
      return this;
    }
  }, {
    key: "_setStrokeStyle",
    value: function _setStrokeStyle() {
      if (!this._lineStyleChanged) {
        return;
      }
      this._lineStyleChanged = false;
      var s = this._lineStyle;
      this._gra.lineStyle(s.thickness, s.color, s.alpha);
    }

    /**
     * @param color {string}
     * @param result
     * @private
     */
  }, {
    key: "_parseRGBCssStyleColor",
    value: function _parseRGBCssStyleColor(color, result) {
      if (!color) {
        return;
      }
      color = color.replace('/s/', '');
      if (color[0] === '#') {
        result.color = parseInt(color.substr(1), 16);
        return;
      }
      var regexResult;
      regexResult = /^rgba\((\d+),(\d+),(\d+),(\d+(\.?\d*))\)$/i.exec(color);
      if (regexResult) {
        result.color = this._RGBToNumber(regexResult);
        result.alpha = Number(regexResult[4]);
        return;
      }
      regexResult = /^rgb\((\d+),(\d+),(\d+)\)$/i.exec(color);
      if (regexResult) {
        result.color = this._RGBToNumber(regexResult);
      }
    }
  }, {
    key: "_RGBToNumber",
    value: function _RGBToNumber(regexResult) {
      var _regexResult = (0, _slicedToArray2["default"])(regexResult, 4),
        x = _regexResult[0],
        r = _regexResult[1],
        g = _regexResult[2],
        b = _regexResult[3];
      return (r << 16) + (g << 8) + Number(b);
    }
  }, {
    key: "quadraticCurveTo",
    value: function quadraticCurveTo(cpX, cpY, toX, toY) {
      this._gra.quadraticCurveTo(cpX, cpY, toX, toY);
      return this;
    }
  }, {
    key: "drawEllipse",
    value: function drawEllipse(x, y, width, height) {
      this._gra.drawEllipse(x, y, width, height);
      return this;
    }
  }]);
}(); // createjs tiny api
var GP = GraphicsAdaptor.prototype;
GP.mt = GP.moveTo;
GP.f = GP.beginFill;
GP.s = GP.beginStroke;
GP.rr = GP.drawRoundRect;
GP.dc = GP.drawCircle;
GP.lt = GP.lineTo;
GP.ss = GP.setStrokeStyle;
GP.rect = GP.r = GP.dr = GP.drawRect;
GP.cp = GP.closePath;
GP.es = GP.endStroke;
GP.qt = GP.quadraticCurveTo;
GP.de = GP.drawEllipse;
function PIXIGraphicOverride() {
  var p = _pixi.Graphics.prototype;
  Object.defineProperties(p, {
    graphics: {
      get: function get() {
        if (!this.___adaptor___) {
          this.___adaptor___ = new GraphicsAdaptor(this);
        }
        return this.___adaptor___;
      }
    }
  });
}